export enum LocalStorageKey {
  REDIRECT_URL = 'redirectToUrl',
  STUDENT_CURRENT_LESSON_ID = 'scl',
  STUDENT_CURRENT_CONTENT_ID = 'scc',
  DEVICE_INFO = 'did',
  SESSION_TIME_TRACKING = 'sstt'
}
